import { ShieldCheck, MapPin, Building2, HeartHandshake } from "lucide-react";
import { PageHeader, PrimaryBtn, OutlineBtn, TrustStrip } from "@/components/site/shared";
import { TEL, PHONE } from "@/lib/config";
import { useContent } from "@/lib/ContentContext";
import { resolveImage } from "@/lib/api";

const VALUES = [
  { icon: ShieldCheck, t: "Veteran Ownership", d: "Founded and operated with the discipline and integrity of military service." },
  { icon: HeartHandshake, t: "Respect for Your Property", d: "We treat every customer's property with care, start to finish." },
  { icon: Building2, t: "Residential & Commercial", d: "Dependable exterior cleaning for homes and businesses alike." },
  { icon: MapPin, t: "Local Orlando Service", d: "Proudly serving the Orlando area with professional results." },
];

export default function About() {
  const { content } = useContent();
  return (
    <div>
      <PageHeader overline="About Us" title="Veteran-Owned. Locally Committed." />
      <section className="section-pad">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="rounded-3xl overflow-hidden aspect-[4/5] bg-[var(--navy)] flex items-center justify-center">
            {content.owner_photo ? <img src={resolveImage(content.owner_photo)} alt="Owner" className="w-full h-full object-cover" />
              : <img src="/brand/logo.png" alt="Veterans Power Wash" className="w-3/4 h-3/4 object-contain" />}
          </div>
          <div>
            <p className="text-[var(--text-muted)] leading-relaxed text-lg">{content.owner_story}</p>
            {content.military_details && <p className="text-[var(--text-muted)] leading-relaxed mt-4">{content.military_details}</p>}
            <div className="mt-6 flex flex-wrap gap-3">
              <PrimaryBtn to="/get-a-quote">Get a Free Quote</PrimaryBtn>
              <OutlineBtn href={TEL}>Call {PHONE}</OutlineBtn>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {VALUES.map((v) => (
            <div key={v.t} className="bg-[var(--bg-light)] border border-gray-100 rounded-2xl p-6">
              <v.icon className="w-8 h-8 text-[var(--action)] mb-3" />
              <h3 className="font-head font-bold text-lg text-[var(--navy)] uppercase">{v.t}</h3>
              <p className="text-sm text-[var(--text-muted)] mt-1">{v.d}</p>
            </div>
          ))}
        </div>
        <div className="max-w-7xl mx-auto px-4 mt-10"><TrustStrip /></div>
      </section>
    </div>
  );
}
